var React = require('react');

function NoDryClean (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("ellipse",{"className":"cls-1","cx":"34.65","cy":"34.65","rx":"25.45","ry":"25.66","key":0}),React.createElement("line",{"className":"cls-1","x1":"68.67","y1":".64","x2":".64","y2":"68.67","key":1}),React.createElement("line",{"className":"cls-1","x1":".98","y1":".64","x2":"69.01","y2":"68.67","key":2})])]);
}

NoDryClean.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 69.65 69.3"};

module.exports = NoDryClean;

NoDryClean.default = NoDryClean;
